import i18n from "./i18n";
window.I18n = i18n;
i18n.defaultLocale = 'ja'
i18n.locale = 'ja'
i18n.fallbacks = true
export default I18n = i18n;
